// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d3dccaf2","977":"e3b37631"}[chunkId] + ".chunk.js";
};